import ColorPicker from './color-picker';
export * from './color-picker';
export default ColorPicker;